<template>
  <div class="container">
    <router-link :to="{ name: 'home' }" class="logo-link">
      <img v-if="logo" :src="logo" class="logo" />
      <h1 class="title">{{ title }}</h1>
      <el-badge value="beta" class="badge" type="primary" />
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Dr. Ashtetepe",
      logo: require("@/assets/images/logo.png")
    };
  }
};
</script>

<style scoped lang="sass">

.container
  position: relative
  height: 50px
  line-height: 50px
  padding-left: 20px

  .logo-link
    height: 100%
    width: 100%

  .logo
    width: 32px
    height: 32px
    vertical-align: middle
    margin-right: 12px

  .title 
    display: inline-block
    margin: 0
    color: $--menu-text-color
    font-weight: bold
    line-height: 50px
    font-size: 1.5em
    vertical-align: middle

  .badge
    transform: translate(-17px, -6px) rotate(40deg) 

// .el-badge__content
    border: none


</style>
